export const licenseKey="ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImZmZmQ1ODkwLTcyMGMtNDU0My04Y2U3LWE3YTdlNTEzMDkxZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.k4SzX+ZhTnnYMjYRmX5UNKNBcjShfdvqmsHjqrWwX4JeK6rj2vs4iQ8DN87iamxOowtwQ760ha7zBUCIE/Cw7D/m7ExhZLReNSUEsTe6yNkHChMNMYKQhnfRMvEI7BnsI3E+lQ=="

